import { RequestedFieldOptionsEditor } from "./requested-field-options-editor"

/**
 * Builder extra for a `choice` requested field: the comma/newline options editor.
 *
 * Registered as the `RequestedFieldEditor("choice")` slot plug (see `share-link-fields.runtime.js`).
 * Rendered inside the row's `<Bound target={field}>`, so the underlying `RequestedFieldOptionsEditor`
 * binds straight to the field's `options` array. This replaces the inline `<If value={type === "choice"}>`
 * block previously in `requested-field-row.js`.
 */
export function ChoiceOptionsEditor() {
    return <RequestedFieldOptionsEditor />
}
